import React from "react";
import style from "./HowOrder.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

const HowOrder: React.FC = () => {
  return (
    <PageLayout className={style.HowOrder}>
      <h1 className={style.Title}>Jak zamówić transport?</h1>

      <div className={style.Section}>
        <h2>1. Wybierz lokalizację</h2>

        <p>
          Wybierz województwo z listy. System wyświetli firmy działające
          w wybranym regionie.
        </p>
      </div>

      <div className={style.Section}>
        <h2>2. Wybierz typ pojazdu</h2>

        <p>
          Skorzystaj z filtrów i wybierz pojazd dopasowany do rodzaju
          ładunku (np. furgonetka, plandeka, HDS, kontener,
          wywrotka, koparka).
        </p>
      </div>

      <div className={style.Section}>
        <h2>3. Użyj dodatkowych filtrów</h2>

        <p>Możesz zawęzić wyniki według:</p>

        <ul>
          <li>Transport międzynarodowy</li>
          <li>ADR – przewóz materiałów niebezpiecznych</li>
        </ul>
      </div>

      <div className={style.Section}>
        <h2>4. Skontaktuj się z firmą</h2>

        <p>
          Platforma nie pośredniczy w zleceniu – kontaktujesz się
          bezpośrednio z wybraną firmą telefonicznie lub mailowo.
        </p>
      </div>

      <div className={style.Section}>
        <h2>Jakie informacje przygotować?</h2>

        <h3>📦 Informacje o ładunku:</h3>

        <ul>
          <li>Nazwa towaru</li>
          <li>Czy towar jest niebezpieczny (ADR)</li>
          <li>Czy jest paletowany</li>
          <li>Liczba palet</li>
          <li>Łączna waga</li>
        </ul>

        <h3>🚛 Wymagania techniczne:</h3>

        <ul>
          <li>Czy potrzebny jest HDS / dźwig</li>
          <li>Czy miejsce załadunku posiada rampę</li>
          <li>Czy transport ma charakter międzynarodowy</li>
        </ul>
      </div>

      <div className={style.Highlight}>
        Bez pośredników. Bez prowizji. Bez zbędnych formalności.
      </div>
    </PageLayout>
  );
};

export default HowOrder;